import { auth } from 'utils'
import store from 'vx/store'

export default async (to, from, next) => {
  const requiresAuth = to.matched.some(route => route.meta.requiresAuth === true)

  try {
    await auth.attemptViaToken()

    const userHasOneTimePassword = store.state.auth.user.id !== undefined &&
      store.state.auth.user.one_time_password === true

    if (userHasOneTimePassword) {
      if (to.name === 'update-password') {
        next()
      } else {
        next({ name: 'update-password', replace: true })
      }
    } else if (requiresAuth) {
      next()

      // Otherwise, force them to the dashboard if they try to access an
      // unprotected route.
    } else {
      next({ name: 'dashboard', replace: true })
    }
  } catch (error) {
    if (requiresAuth) {
      await auth.redirectOnTokenExpired(to)
    } else {
      next()
    }
  }
}
